import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'invoicelist' })
export class InvoiceListPipe implements PipeTransform {
    transform(value:any[],searchText:string ){

       if(!searchText){
  //       console.log('no search')
         return value  
       }

       return value.filter(it=>{   
           const ponumber = it.ponumber.toString().toLowerCase().includes(searchText.toLowerCase())
           const invoiceno = it.invoiceno.toString().toLowerCase().includes(searchText.toLowerCase())
		    const vendorname = it.vendorname.toString().toLowerCase().includes(searchText.toLowerCase())
			
          
           return (ponumber + invoiceno  + vendorname );      
       }) 
    }
}